import { EmeshApiClient } from "@/typescript/api_client/emesh_api/client";
import { getBearerToken } from "@/typescript/lib/common/get_bearer_token";
import { download } from "@/typescript/lib/common/download";
import { GetStoreReportHistoryDownloadErrorResponse } from "@/typescript/api_client/emesh_api/reports/types";

const emeshApiClient: EmeshApiClient = new EmeshApiClient(
  "/v1/store_report/history/download"
);

export async function getStoreReportHistoryDownloadApi(
  historyNo: number,
  urlFileName: string
) {
  return await emeshApiClient
    .get({
      params: {
        history_no: historyNo
      },
      headers: {
        Authorization: getBearerToken()
      },
      responseType: "blob"
    })
    .then(resp => {
      const contentDisposition = resp.headers["content-disposition"];
      if (contentDisposition) {
        const fileName = getFileName(contentDisposition);
        download(resp.data, fileName);
      } else {
        // バイナリの取得はダウンロードを適用
        download(resp.data, urlFileName);
        // Content-Dispositionがない場合はページ表示
        //const fileUrl = window.URL.createObjectURL(resp.data);
        //location.href = fileUrl;
        //window.open(fileUrl);
        // revokeObjectURLで一時データページを削除すると
        // 表示ページを手動ダウンロードできなくなるので実行しない
        // setTimeout(() => {
        //   window.URL.revokeObjectURL(fileUrl);
        // }, 200);
      }
    })
    .catch(e => {
      if (e.data) {
        return Promise.reject(
          e.data as GetStoreReportHistoryDownloadErrorResponse
        );
      }
      return Promise.reject(e);
    });
}
function getFileName(contentDisposition) {
  if (!contentDisposition) return "";
  let fileName = contentDisposition.substring(
    contentDisposition.indexOf("filename=") + 9,
    contentDisposition.length
  );
  // デコードするとスペースが"+"になるのでスペースへ置換
  fileName = decodeURI(fileName).replace(/\+/g, " ");
  return fileName;
}
